import React from 'react'
import { AuthService } from '../../services'
import JobMyJob from '../../components/job/job-myjob'
import { PageHeader } from 'antd'

const isAuthenticated = AuthService.isLoggedIn()

class MyJobPage extends React.Component {
  state = {
    initLoading: true,
  }

  render() {
    const { match } = this.props
    return (
      <div>
        <PageHeader title="งานของฉัน">
          <p>ระบบจะแสดงงานที่ มีผู้รับผิดชอบ เป็นคุณเท่านั้น</p>
        <JobMyJob />
        </PageHeader>
      </div>
    )
  }
}

export default MyJobPage
